// extracted by mini-css-extract-plugin
module.exports = {"eduBody":"EduBody_eduBody__WqRaF","eduNav":"EduBody_eduNav__SFSns","title":"EduBody_title__5UW2h","active":"EduBody_active__no9hs"};